import CircleIcon from '@mui/icons-material/Circle'
import { Stack, Typography } from '@mui/material'
import { Row } from '@/components/horizontalTable/HorizontalTable.types'
import { bytesToHumanReadable } from '@/utils/bytesToHumanReadable'
import { formatNumberToSI } from '@/utils/formatNumberToSI'
import { secondsToHMS } from '@/utils/secondsToHMS'

import { toPercentage } from '../../utils'
import { SportPopularityTableData } from './SportPopularity'

export const SPORT_POPULARITY_ROWS: Row<SportPopularityTableData>[] = [
  {
    id: 'label',
    label: 'Sport',
    transform: (value) => (
      <Stack gap={1} direction="row" alignItems="center">
        <CircleIcon
          fontSize="small"
          sx={{
            color: value.color
          }}
        />
        <Typography variant="body2" noWrap>
          {value.label}
        </Typography>
      </Stack>
    )
  },
  {
    id: 'percentageViews',
    label: 'Percentage Views',
    transform: (value) => toPercentage(value.percentageViews)
  },
  {
    id: 'totalViews',
    label: 'Total Views'
  },
  {
    id: 'uniqueViews',
    label: 'Unique Views'
  },
  {
    id: 'totalDuration',
    label: 'Total Minutes',
    transform: ({ totalDuration }) => formatNumberToSI(totalDuration)
  },
  {
    id: 'averageDuration',
    label: 'Average Duration',
    transform: ({ averageDuration }) => secondsToHMS(averageDuration)
  },
  {
    id: 'totalBytes',
    label: 'Total Bytes',
    transform: ({ totalBytes }) => bytesToHumanReadable(totalBytes, { space: true, digits: 0 })
  }
]
